<template>
  <div class="input-wrapper hd">
    <slot
      :condition="condition"
      :pickerOptions="pickerOptions"
      :searchData="searchData"
    />
  </div>
</template>
<script>
import pickerOptions from 'mixins/pickerOptions/'
export default {
  name: 'SearchComponent',
  mixins: [pickerOptions],
  props: {
    condition: {
      type: Object,
      default: () => {}
    },
    routeName: {
      type: String
    }
  },
  methods: {
    /**
     * 返回搜索条件
     */
    searchData() {
      const condition = this._returnSearchCondition()
      this.$emit('updateData', vm => {
        switch (this.routeName) {
          case 'shippingTemplate':
            vm._getTransportList({
              curpage: vm.pagination.currentPage,
              ...condition
            })
            break
          case 'salesArea':
            vm._getSalesAreaList({
              curpage: vm.pagination.currentPage,
              ...condition
            })
            break
        }
      })
    },
    /**
     * 返回搜索条件
     * @private
     */
    _returnSearchCondition() {
      const { shippingName, time, salesAreaName } = this.condition
      const condition = {
        transport_title: shippingName,
        start_time: time[0] || '',
        end_time: time[1] || '',
        sales_title: salesAreaName
      }
      this.utils._checkSearchCondition(condition)
      return condition
    }
  }
}
</script>
